import { action } from 'satcheljs';

import type { AccountSource } from '../store/schema/AccountSourceList';
import type { BootState } from '../store/schema/BootState';

export interface ON_COPRINCIPAL_BOOTSTATE_CHANGEDActionMessage {
    updatedAccount: AccountSource;
    newBootState: BootState;
}
const defaultExport: (
    updatedAccount: AccountSource,
    newBootState: BootState
) => ON_COPRINCIPAL_BOOTSTATE_CHANGEDActionMessage = action(
    'ON_COPRINCIPAL_BOOTSTATE_CHANGED',
    (
        updatedAccount: AccountSource,
        newBootState: BootState
    ): ON_COPRINCIPAL_BOOTSTATE_CHANGEDActionMessage => ({
        updatedAccount,
        newBootState,
    })
);
export default defaultExport;
